<template>
  <TsSection class="md:mt-2 mt-4">
    <TsTypography append-class="mb-2" weight="normal" as="h3">
      {{useTranslation('AccountSaveList-noSaveListFound','Geen bewaarlijst gevonden!')}}
    </TsTypography>
    <TsTypography append-class="mb-4" wei   ght="normal" as="h4">
      {{useTranslation('AccountSaveList-createNewSaveList','Create a new savelist to begin!')}}
    </TsTypography>

    <TsImage
      width="90"
      class="text-center mx-auto"
      src="/images/searchResultNotFound.svg"
      loading="lazy"
    />
  </TsSection>
</template>
